
export default {
  name: 'confirmacao-dados',
  components: {
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    novosDados: {
      type: Object,
      default: () => {}
    },
    mapeamentoCampos: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    mostrarModal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    formatarDados () {
      return Object.entries(this.novosDados).map(([chave, valor]) => ({
        campo: this.mapeamentoCampos[chave] || chave,
        valor: typeof valor === 'object' ? valor?.label ?? valor?.code : valor || 'Não informado'
      }))
    }
  },

  data: () => {
    return {
    }
  },
  mounted () {
  },

  methods: {
    confirmar () {
      this.mostrarModal = false
      this.$emit('confirmar', this.novosDados)
    },
    cancelar () {
      this.mostrarModal = false
      this.$emit('fechar')
    }
  }
}
